import type { CartLine } from '../pos.schema';

// Ported from kritware-pos/src/reducers/sale.js (calculateTotal / calculateDiscounts /
// calculateQuantity). Discount math and rounding kept identical so receipts match.

const round2 = (n: number) => Math.round(n * 100) / 100;

// Recompute each discount's resolved `value` and the line's `discountedPrice`.
// Mutates the line in place (called inside immer reducers).
export function recalcLineDiscounts(line: CartLine): CartLine {
    let unitPrice = line.price;
    for (const discount of line.discounts) {
        if (discount.type === 'procentual') {
            discount.value = Math.round(unitPrice * discount.discount) / 100;
            unitPrice -= Math.round(unitPrice * discount.discount) / 100;
        } else {
            discount.value = discount.discount;
            unitPrice -= discount.discount;
        }
    }
    line.discountedPrice = round2(unitPrice);
    return line;
}

export function lineUnitPrice(line: CartLine): number {
    let unitPrice = line.price;
    for (const discount of line.discounts) {
        if (discount.type === 'procentual') {
            unitPrice -= Math.round(unitPrice * discount.discount) / 100;
        } else {
            unitPrice -= discount.discount;
        }
    }
    return unitPrice;
}

export function cartTotal(lines: CartLine[], globalDiscounts: number[] = []): number {
    let total = 0;
    for (const line of lines) {
        total += lineUnitPrice(line) * line.quantity;
    }
    for (const d of globalDiscounts) {
        total -= d;
    }
    return round2(total);
}

export function cartQuantity(lines: CartLine[]): number {
    return lines.reduce((sum, line) => sum + line.quantity, 0);
}
